
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"id-24a","x1":"0%","x2":"100%","y1":"50%","y2":"50%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#EDEFF6"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#D6DBEA"}})])]),_c('path',{attrs:{"fill":"url(#id-24a)","fill-rule":"evenodd","d":"M21.417 17.662a3.75 3.75 0 110 7.5 3.75 3.75 0 110-7.5zm11.943 7.855a1.711 1.711 0 00-1.527-.92 1.679 1.679 0 00-1.486.976l-2.597 5.724a.416.416 0 01-.703.088l-1.367-1.707a1.67 1.67 0 00-1.355-.626 1.678 1.678 0 00-1.312.71l-5.196 7.421A.833.833 0 0018.5 38.5h20a.834.834 0 00.745-1.205L33.36 25.517zM41.683 11H14.317A3.316 3.316 0 0011 14.317v27.366A3.316 3.316 0 0014.317 45h27.366A3.316 3.316 0 0045 41.683V14.317A3.316 3.316 0 0041.683 11zm.07 30.752a.847.847 0 01-.6.248H14.848a.849.849 0 01-.848-.848V14.848c0-.468.38-.848.848-.848h26.304c.468 0 .848.38.848.848v26.304a.841.841 0 01-.246.595v.005z"}})])
          )
        }
      }
    